function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.583 16.04v27.083h5.688a5.895 5.895 0 013.42-1.083c1.276 0 2.448.399 3.418 1.083h19.974V16.04z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.083 21.54v21.667H16.211a6.001 6.001 0 011.896 2.167h18.62a5.943 5.943 0 015.315-3.25c2.318 0 4.33 1.309 5.315 3.25h6.06V31.562L48 21.54zm2.573 2.674h7.922l3.588 6.873h-11.51zM2.5 43.14v2.167h4.977a6.002 6.002 0 011.895-2.167z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 48.04a5.958 5.958 0 11-11.917 0 5.958 5.958 0 0111.917 0zM18.75 48.04a5.958 5.958 0 11-11.917 0 5.958 5.958 0 0111.917 0z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.292 19.34h10.833M6.292 22.54h19.5M6.292 25.84h16.246M6.292 29.04h13M6.292 32.34h10.835M16.042 48.04a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0zM45.292 48.04a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0z"
})));

var SvgTruck = function SvgTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Truck.a271180b.svg";
export { ForwardRef as ReactComponent };